import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconZipSizeM from './FileIconZip_size_m';
import FileIconZipSizeS from './FileIconZip_size_s';

export const FileIconZip = createFileIcon({
  m: FileIconZipSizeM,
  s: FileIconZipSizeS,
  name: 'FileIconZip',
});
